// Purpose: Generates small reusable, structural BayHive utility compositions.
export const compositionUtilityStyles = ({ dt }) => `
/* History restoration and page changes must finish before the next render.
   Explicit smooth section jumps and the Back to top button keep their behavior. */
html[data-ui-brand='bayhive'] {
  scroll-behavior: auto;
}

html[data-ui-brand='bayhive'] .bayhive-fill-page-card.p-card {
  display: flex;
  flex: 1 1 auto;
  min-height: 0;
  overflow: hidden;
}

html[data-ui-brand='bayhive'] :is(
  .bayhive-fill-page-card > .p-card-body,
  .bayhive-fill-page-card > .p-card-body > .p-card-content
) {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
  overflow: hidden;
}

html[data-ui-brand='bayhive'] .bayhive-fill-page-card > .p-card-body > .p-card-content {
  gap: ${dt('bayhive.spacing.md')};
}

html[data-ui-brand='bayhive'] .bayhive-fill-data-table.p-datatable {
  display: flex;
  flex: 1 1 auto;
  flex-direction: column;
  min-height: 0;
}

html[data-ui-brand='bayhive'] .bayhive-fill-data-table > .p-datatable-table-container {
  flex: 1 1 auto;
  min-height: 0;
}

html[data-ui-brand='bayhive'] .bayhive-datepicker-input-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: ${dt('icon.size')};
  height: ${dt('icon.size')};
  line-height: 1;
}

html[data-ui-brand='bayhive'] .shop-management-command-clear.p-button {
  position: absolute;
  inset-inline-end: ${dt('bayhive.spacing.xs')};
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
}
`;

export default compositionUtilityStyles;
